// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dusknoir: PokeData = {
  "id": 477,
  "name": "dusknoir",
  "height": 22,
  "weight": 1066,
  "base_experience": 236,
  "types": [
    PokeType.GHOST
  ],
  "api_moves": [
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "bind",
    "leer",
    "disable",
    "absorb",
    "psychic",
    "night-shade",
    "confuse-ray",
    "leech-life",
    "curse",
    "foresight",
    "destiny-bond",
    "mean-look",
    "pursuit",
    "shadow-ball",
    "future-sight",
    "will-o-wisp",
    "astonish",
    "shadow-punch",
    "gravity",
    "payback",
    "dark-pulse",
    "shadow-sneak",
    "hex"
  ],
  "moves": [
    "fire-punch",
    "ice-punch",
    "thunder-punch",
    "leer",
    "psychic",
    "night-shade",
    "confuse-ray",
    "curse",
    "pursuit",
    "shadow-ball",
    "future-sight",
    "dark-pulse",
    "shadow-sneak"
  ],
  "evolution_chain": {
    "id": 182,
    "item": null,
    "species": [
      {
        "name": "duskull",
        "order": 383,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dusclops",
        "order": 384,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 355,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dusknoir",
        "order": 385,
        "types": [
          PokeType.GHOST
        ],
        "evolves_from_species_id": 356,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 153,
    "speed": 77,
    "ability_power": 170
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
